import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
});

export const apiUrl = (path) => `${BACKEND_URL}/api${path}`;

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Une erreur est survenue. Réessayez.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function fmtEUR(value, currency) {
    const n = Number(value || 0);
    // Default to EUR when no currency is provided (preserves backward
    // compatibility for aggregates / dashboards). Per-document totals
    // should pass `inv.currency` so USD/GBP/CHF/... display correctly.
    const code = (currency || "EUR").toString().toUpperCase();
    try {
        return new Intl.NumberFormat("fr-FR", { style: "currency", currency: code }).format(n);
    } catch {
        // Unknown ISO code → fall back to EUR rather than crashing.
        return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n);
    }
}

export function fmtDate(iso) {
    if (!iso) return "—";
    try {
        const d = typeof iso === "string" ? new Date(iso) : iso;
        return new Intl.DateTimeFormat("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" }).format(d);
    } catch {
        return "—";
    }
}

export function fmtMonth(period) {
    if (!period) return "";
    const [y, m] = period.split("-");
    const months = ["jan", "fév", "mar", "avr", "mai", "juin", "juil", "août", "sep", "oct", "nov", "déc"];
    return `${months[parseInt(m, 10) - 1]} ${y.slice(2)}`;
}
